class DrawingHandler {
  constructor(map, onComplete) {
    this.map = map;
    this.onComplete = onComplete;
    this.drawing = false;
    this.path = [];
    this.polyline = null;
    this.listeners = [];
  }

  // Starts drawing mode and adds listeners to the map
  start() {
    if (!this.map) {
      return;
    }

    // Creates the line that will be drawn
    this.polyline = new window.google.maps.Polyline({
      map: this.map,
      path: [],
      strokeColor: '#3483FA',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      clickable: false,
    });

    // When clicking/touching, drawing starts
    const onStart = (e) => {
      this.drawing = true;
      this.path = [];
      this.polyline.setPath(this.path);

      // Prevent default behavior for touch events
      if (e.domEvent?.preventDefault) {
        e.domEvent.preventDefault();
      }
    };

    // While moving the mouse/finger, points are added to the path
    const onMove = (e) => {
      if (!this.drawing) {
        return;
      }

      const { latLng } = e;

      this.path.push(latLng);
      this.polyline.setPath(this.path);

      // Prevent default behavior for touch events
      if (e.domEvent?.preventDefault) {
        e.domEvent.preventDefault();
      }
    };

    // When releasing the mouse/finger, drawing ends and the callback is triggered
    const onEnd = (e) => {
      if (!this.drawing) {
        return;
      }

      this.drawing = false;

      const simplifiedPath = this.path.map((latLng) => ({
        lat: latLng.lat(),
        lng: latLng.lng(),
      }));

      if (this.onComplete && simplifiedPath.length > 2) {
        this.onComplete(simplifiedPath);
      }

      // Prevent default behavior for touch events
      if (e?.domEvent?.preventDefault) {
        e.domEvent.preventDefault();
      }

      this.cleanup();
    };

    // Mouse events listeners
    this.listeners.push(
      this.map.addListener('mousedown', onStart),
      this.map.addListener('mousemove', onMove),
      this.map.addListener('mouseup', onEnd),
    );

    // Touch events listeners for mobile devices
    this.listeners.push(
      this.map.addListener('touchstart', onStart),
      this.map.addListener('touchmove', onMove),
      this.map.addListener('touchend', onEnd),
    );
  }

  // Cleans up listeners and removes the line from the map
  cleanup() {
    this.listeners.forEach((listener) => window.google.maps.event.removeListener(listener));
    this.listeners = [];

    if (this.polyline) {
      this.polyline.setMap(null);
      this.polyline = null;
    }

    this.drawing = false;
  }
}

export default DrawingHandler;
